import { formatInTimeZone } from "date-fns-tz";
import { es } from "date-fns/locale";

/**
 * Las fechas de evento se guardan con la hora que el admin escribió en el
 * formulario (ej. datetime-local "17:59"), pero el backend le agrega el
 * sufijo "Z" sin convertir realmente a UTC (el API devuelve
 * "...T17:59:00.000Z", no la hora de Lima ya convertida a UTC). Por eso todo
 * el formateo debe leer los dígitos tal cual usando timezone "UTC", en vez
 * de aplicar un desplazamiento adicional que restaría horas de más.
 */
const RAW_TIMEZONE = "UTC";

export function formatEventDate(date, formatStr) {
  if (!date) return "";
  return formatInTimeZone(new Date(date), RAW_TIMEZONE, formatStr, {
    locale: es,
  });
}

export function formatEventTime12h(date) {
  return formatEventDate(date, "hh:mm a");
}

// Convierte una hora "HH:mm" (24h) tal como la devuelve el API a formato 12h.
// Algunos locales (ej. "es-PE" en Node) formatean la medianoche como "24:mm"
// en vez de "00:mm"; se normaliza aquí para no romper el parseo de fecha.
export function formatTimeString12h(timeStr) {
  if (!timeStr) return "";
  const normalized = timeStr.startsWith("24:") ? `00:${timeStr.slice(3)}` : timeStr;
  return formatEventDate(`1970-01-01T${normalized}:00Z`, "hh:mm a");
}
